import{uniqueId as t}from"lodash";function n(r=""){return`${Math.random().toString(36).substr(2,5)}${t(r)}`}export{n as generateId};
//# sourceMappingURL=generateRandomId.js.map
